module.exports = __webpack_public_path__ + "static/media/sg.46ec53e6.svg";